module.exports = __webpack_public_path__ + "img/page9.f225de87.png";